import { useEffect, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const MOBILE_DATE_QUERY = "(max-width: 1180px), (pointer: coarse)";

const shouldUseNativeDateInput = () =>
  typeof window !== "undefined" && window.matchMedia(MOBILE_DATE_QUERY).matches;

export default function ResponsiveDatePicker({
  value,
  onChange,
  onBlur,
  className = "",
  style,
  placeholder = "วันหมดอายุ",
  disabled = false,
  id,
  name,
  ...datePickerProps
}) {
  const [useNativeInput, setUseNativeInput] = useState(shouldUseNativeDateInput);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_DATE_QUERY);
    const updateInputMode = () => setUseNativeInput(mediaQuery.matches);

    updateInputMode();
    mediaQuery.addEventListener?.("change", updateInputMode);
    window.addEventListener("orientationchange", updateInputMode);
    window.addEventListener("resize", updateInputMode);

    return () => {
      mediaQuery.removeEventListener?.("change", updateInputMode);
      window.removeEventListener("orientationchange", updateInputMode);
      window.removeEventListener("resize", updateInputMode);
    };
  }, []);

  if (!useNativeInput) {
    return (
      <DatePicker
        {...datePickerProps}
        id={id}
        className={className}
        style={style}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
      />
    );
  }

  const parsedValue = value ? dayjs(value) : null;
  const nativeValue = parsedValue?.isValid()
    ? parsedValue.format("YYYY-MM-DD")
    : "";

  return (
    <input
      id={id}
      name={name}
      type="date"
      className={`neo-native-date-input ${className}`.trim()}
      style={style}
      value={nativeValue}
      aria-label={placeholder}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(event) => {
        const dateText = event.target.value;
        onChange?.(dateText ? dayjs(dateText) : null, dateText);
      }}
    />
  );
}
